import "./_style.scss";
import {BitrixVue} from 'ui.vue3';
import {createPinia, mapState} from 'ui.vue3.pinia';
import {Notification} from './ui/notification';

// данный комментарий нужен для корректной кодировки
const $appContainer = document.getElementById('notifications');
const notificationStore = createPinia();

if ($appContainer) {
    const fragment = document.createDocumentFragment();

    BitrixVue.createApp({
        name: 'notifications',
        components: {Notification},
        computed: {
            ...mapState(useGlobalStorage, ['notifications']),
        },
        props: {
            className: {
                data: String,
                default: '',
            },
        },
        template: `
      <div class="notifications" :class="className" v-if="notifications?.state?.length">
      <Notification
          v-for="notification in notifications?.state"
          :key="notification?.id"
          :id="notification?.id"
          :type="notification?.type"
          :title="notification?.title"
          :description="notification?.description"
          :closeBtnText="notification?.closeBtnText"
          :actionBtnText="notification?.actionBtnText"
          :closeBtnHandler="notification?.closeBtnHandler"
          :actionBtnHandler="notification?.actionBtnHandler"
      />
      </div>
    `
    }).use(notificationStore).mount(fragment);

    $appContainer.parentNode.replaceChild(fragment, $appContainer);
}

export {notificationStore};
